<template>
  <div class="item-standart"
       v-if="showItem">
    <div class="avatar">
      <child-avatar :child="child"
                    size="small"
                    icon="IconTick"
                    icon-color="#fff"
                    icon-background-color="#2ad678"
                    :show-status="false" />
    </div>
    <div class="content">
      <div class="description">
        {{ $t("feed.items.installItemTitle") }}
      </div>

      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'

  export default {
    extends: ItemBase,

    props: {
      item: {
        required: true,
        type: Object
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.item.user_id)
      },

      showItem() {
        return this.child
      }
    }
  }
</script>
